
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Phone, Search, Smartphone } from 'lucide-react';

const ShopwareCallToAction = () => {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-blue-50 to-gray-100">
      <div className="container">
        <div className="text-center max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            <span className="text-blue-600">Kostenloser</span> Shop Checkup-Call
          </h2>
          <p className="text-xl text-gray-700 mb-12">
            Lass uns gemeinsam deinen Shop entwickeln oder optimieren – für nachhaltigen Erfolg im E-Commerce.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
            <Card className="h-full">
              <CardContent className="p-6 flex flex-col h-full items-center text-center">
                <div className="rounded-full bg-blue-100 p-4 mb-4">
                  <Search className="h-8 w-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-bold mb-3">Anforderungen analysieren</h3>
                <p className="text-gray-600">
                  Im Erstgespräch analysieren wir deine Zielgruppe, Produkte und Anforderungen für deinen optimalen Shopware-Shop.
                </p>
              </CardContent>
            </Card>
            
            <Card className="h-full">
              <CardContent className="p-6 flex flex-col h-full items-center text-center">
                <div className="rounded-full bg-blue-100 p-4 mb-4">
                  <Smartphone className="h-8 w-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-bold mb-3">Strategien entwickeln</h3>
                <p className="text-gray-600">
                  Wir erarbeiten eine maßgeschneiderte E-Commerce-Strategie für deinen Shop mit konkreten Umsetzungsschritten.
                </p>
              </CardContent>
            </Card>
            
            <Card className="h-full">
              <CardContent className="p-6 flex flex-col h-full items-center text-center">
                <div className="rounded-full bg-blue-100 p-4 mb-4">
                  <Phone className="h-8 w-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-bold mb-3">Konkretes Angebot</h3>
                <p className="text-gray-600">
                  Nach dem Gespräch erhältst du ein transparentes Angebot mit allen Leistungen und einem realistischen Zeitplan.
                </p>
              </CardContent>
            </Card>
          </div>
          
          <Button asChild size="lg" className="bg-blue-600 hover:bg-blue-700 text-white px-10 py-6 text-lg">
            <a href="#contact">Jetzt kostenlosen Shop Checkup-Call vereinbaren</a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ShopwareCallToAction;
